import * as company from '../../actionTypes/Company/Company'
// set the company redux initialState
const initialState = {
  companyDetails: {
    'companyId': 0,
    'companyUId': '',
    'companyName': '',
    'companyType': '',
    'companyAvanteCustId': '',
    'addressLine1': '',
    'addressLine2': '',
    'addressLine3': '',
    'addressLine4': '',
    'city': '',
    'state': '',
    'zipcode': '',
    'countryId': 0,
    'phoneNumber': '',
    'faxNumber': '',
    'isOwner': false,
    'status': false
  }
}

// call companyDetails redux action & change the companyDetails  state
export default function companyDetails (state = initialState, action) {
  switch (action.type) {
    case company.GET_COMPANY:
      state.companyDetails = action.companyDetails
      return {
        ...state
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/store/company.js